import React from "react";
import "./FilledButton.css";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

function FilledButton({
  children,
  bgColor = "var(--blue)",
  color = "var(--white)",
  fontSize = "1rem",
  padding = "5px 20px",
  onClick,
  to,
  type = "button",
  className = "",
  target = "_self",
  rel = "",
  hoverColor = "var(--blue)",
  borderRadius = "10px",
  disabled = false,
  isLoading,
  download = false,
  disabledtooltip,
}) {
  const sharedProps = {
    className: `button filled-button ${className} ${disabled && disabledtooltip ? "with-tooltip" : ""} ${disabled ? "disabled" : ""} ${isLoading ? "loading" : ""}`,
    style: {
      "--background-color": disabled ? "var(--grey-alt)" : bgColor,
      "--font-size": fontSize,
      "--hover-color": disabled ? "var(--grey-alt)" : hoverColor,
      "--color": disabled ? "var(--white)" : color,
      "--padding": padding,
      "--border-radius": borderRadius,
    },
    onClick: e => {
      if (disabled) {
        e.preventDefault();
      } else {
        onClick && onClick(e);
      }
    },
    disabled: disabled,
    disabledtooltip: disabledtooltip,
  };

  return (
    <>
      {to && !download ? (
        to.includes("#") ? (
          <HashLink smooth to={to} target={target} {...sharedProps}>
            {children}
            <div className={`button-loader-container ${isLoading ? "" : "hidden"}`}>
              <div className='button-loader' />
            </div>
          </HashLink>
        ) : (
          <Link to={to} rel={rel} target={target} {...sharedProps}>
            {children}
            <div className={`button-loader-container ${isLoading ? "" : "hidden"}`}>
              <div className='button-loader' />
            </div>
          </Link>
        )
      ) : (
        <button type={type} disabled={disabled} {...sharedProps}>
          {children}
          <div className={`button-loader-container ${isLoading ? "" : "hidden"}`}>
            <div className='button-loader' />
          </div>
        </button>
      )}
    </>
  );
}

export default FilledButton;
